<template>
  <div class="min-h-screen bg-gradient-to-br from-blue-50 via-white to-purple-50 p-4 sm:p-6">
    <div class="max-w-7xl mx-auto">
      <!-- Header -->
      <div class="bg-white rounded-xl shadow-lg p-6 mb-6">
        <h1 class="text-3xl font-bold text-gray-900">📊 Dashboard Simple - Test</h1>
        <p class="text-gray-600">Test básico de ApexCharts</p>
      </div>

      <!-- Charts básicas -->
      <div class="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <!-- Gráfica de Línea -->
        <div class="bg-white rounded-xl shadow-lg p-6">
          <h3 class="text-lg font-semibold text-gray-900 mb-4">📈 Cotizaciones por Mes</h3>
          <apexchart 
            type="line" 
            :options="lineOptions" 
            :series="lineSeries"
            height="300"
          ></apexchart>
        </div>
        
        <!-- Gráfica de Área -->
        <div class="bg-white rounded-xl shadow-lg p-6">
          <h3 class="text-lg font-semibold text-gray-900 mb-4">💰 Ventas por Mes</h3>
          <apexchart 
            type="area" 
            :options="areaOptions" 
            :series="areaSeries"
            height="300"
          ></apexchart>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DashboardSimple',
  data() {
    return {
      // Opciones para gráfica de línea
      lineOptions: {
        chart: {
          type: 'line',
          toolbar: { show: false }
        },
        stroke: {
          curve: 'smooth',
          width: 3
        },
        colors: ['#3B82F6'],
        xaxis: {
          categories: ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic']
        },
        yaxis: {
          title: { text: 'Cantidad' }
        }
      },
      
      // Opciones para gráfica de área
      areaOptions: {
        chart: {
          type: 'area',
          toolbar: { show: false }
        },
        fill: {
          type: 'gradient',
          gradient: {
            shadeIntensity: 1,
            opacityFrom: 0.7,
            opacityTo: 0.1
          }
        },
        colors: ['#10B981'],
        xaxis: {
          categories: ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic']
        },
        yaxis: {
          title: { text: 'Monto ($)' }
        }
      }
    }
  },
  
  computed: {
    // Series de datos para línea
    lineSeries() {
      return [{
        name: 'Cotizaciones',
        data: [10, 15, 8, 20, 25, 18, 30, 22, 16, 28, 35, 40]
      }]
    },
    
    // Series de datos para área
    areaSeries() {
      return [{
        name: 'Ventas',
        data: [50000, 75000, 40000, 100000, 125000, 90000, 150000, 110000, 80000, 140000, 175000, 200000]
      }]
    }
  }
}
</script>

<style scoped>
/* Estilos adicionales si es necesario */
</style>
